import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ywxs1y6xb: FaireBrandEntity = {
  token: "b_7ywxs1y6xb",
  type: "brand",
  name: "Sweet on Vermont Artisan Confections",
  location: "Vermont, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
